import(/* webpackMode: "eager" */ "/workspace/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/workspace/components/I18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoggingProvider"] */ "/workspace/components/logging-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/workspace/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopLoader"] */ "/workspace/components/top-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WakeupCall"] */ "/workspace/components/wakeup-call.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WarningBanner"] */ "/workspace/components/warning-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/workspace/node_modules/.pnpm/sonner@1.7.4_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/sonner/dist/index.mjs");
